<template>
    <div class="not-found-page-component-container">
        <div class="component-wrapper">
            <LoginHeader v-if="!loggedInUser"/>
            <AppHeader v-else />
            <div class="not-found-page-container">
                <p>404 Not Found</p>
            </div>
            <LoginFooter v-if="!loggedInUser" />
            <AppFooter v-else />
        </div>
    </div>
</template>

<script>
import LoginHeader from './login/LoginHeader.vue';
import LoginFooter from './login/LoginFooter.vue';
import AppHeader from './home/AppHeader.vue';
import AppFooter from './home/AppFooter.vue';
export default {
    name: 'NotFound404',
    components: {
        LoginHeader,
        LoginFooter,
        AppHeader,
        AppFooter,
    },
    data() {
        return {
            loggedInUser: false,
        };
    },
    async mounted() {
        // console.log(this.$store.user);
        // try {
        //     const loggedInUser = await this.$store.checkLoggedinUser();
        //     if (loggedInUser) {
        //         this.loggedInUser = true;
        //     }
        // }
        // catch(err) {
        //     console.log("Error getting user info");
        //     console.log(err);
        // }
        // if (this.$store.user.email &&  this.$store.user.email !== '') {
        //     console.log(this.$store.user.email);
        //     this.loggedInUser = true;
        // }
    }
}
</script>

<style>
.not-found-page-component-container {
    position: relative;
    height: 100vh;
    width: 100%;
}

.not-found-page-component-container .component-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.not-found-page-component-container .not-found-page-container {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.not-found-page-component-container .not-found-page-container p {
    font-size: 30px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #cb061d;
}
</style>